var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoint2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #fff;\n      }\n\n      .b {\n        fill: #666;\n      }\n\n      .c1 {\n        fill: #455da8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-642.5 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(305 -56)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(337.5 431)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.687 444.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M226.666,98.2H183.1a2.6,2.6,0,0,0-2.593,2.593v36.3a2.6,2.6,0,0,0,2.593,2.593h43.564a2.6,2.6,0,0,0,2.593-2.593v-36.3A2.6,2.6,0,0,0,226.666,98.2Zm-.519,11.409v26.968H183.622V109.608ZM183.62,106.5v-5.184h42.527V106.5Z",
    transform: "translate(-180.509 -94.224)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.813,
    height: 2.813,
    transform: "translate(6.546 8.289)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.813,
    height: 2.813,
    transform: "translate(13.108 8.289)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.813,
    height: 2.813,
    transform: "translate(19.671 8.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M217.356,119.391h-22V106.219l8.2-2.152.014-6.379h13.788Z",
    transform: "translate(-167.52 -94.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.943,108.945a1.262,1.262,0,0,0-.891-.371,5.868,5.868,0,0,1-3.137-1.012,13.964,13.964,0,0,1-5.822-10.253,1.259,1.259,0,0,0-2.518.032,12.907,12.907,0,0,1-2.921,7.393c-1.9,2.4-4.224,3.78-6.4,3.78a1.26,1.26,0,1,0,0,2.52,6.2,6.2,0,0,1,3.309,1.071,13.479,13.479,0,0,1,4.277,4.762,12.556,12.556,0,0,1,1.731,5.822,1.259,1.259,0,1,0,2.518,0,13.94,13.94,0,0,1,2.878-7.68,11.874,11.874,0,0,1,2.942-2.863,5.768,5.768,0,0,1,3.139-1.05,1.26,1.26,0,0,0,.891-2.149Zm-5.107.906c-.1.06-.2.122-.3.186a15.823,15.823,0,0,0-4.969,5.634q-.405.748-.744,1.551a18.335,18.335,0,0,0-2.2-3.758,14.519,14.519,0,0,0-3.7-3.488c-.1-.06-.193-.118-.293-.176a13.872,13.872,0,0,0,4.005-3.5,17.359,17.359,0,0,0,2.214-3.66,17.925,17.925,0,0,0,2.162,3.694,13.937,13.937,0,0,0,3.563,3.356C214.654,109.742,214.744,109.8,214.836,109.851Z",
    transform: "translate(-166.08 -96.079)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.711 17.795)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.032)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.78,105.58v2.272a.765.765,0,1,0,1.529,0V105.58a.765.765,0,1,0-1.529,0",
    transform: "translate(-210.78 -104.815)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.789)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.78,109.445v2.274a.765.765,0,0,0,1.529,0v-2.274a.765.765,0,1,0-1.529,0",
    transform: "translate(-210.78 -108.68)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.791)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.992,107.506h-2.274a.765.765,0,0,0,0,1.531h2.274a.765.765,0,0,0,0-1.531",
    transform: "translate(-211.954 -107.506)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M211.126,107.506h-2.272a.765.765,0,0,0,0,1.531h2.272a.765.765,0,1,0,0-1.531",
    transform: "translate(-208.088 -107.506)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.82 119.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c1",
    d: "M.289,2H5.279a.289.289,0,0,1,.289.289v7.944a.289.289,0,0,1-.289.289H.289A.289.289,0,0,1,0,10.234V2.289A.289.289,0,0,1,.289,2Z",
    transform: "translate(460.18 294.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c1",
    d: "M.289,1H5.279a.289.289,0,0,1,.289.289V12.373a.289.289,0,0,1-.289.289H.289A.289.289,0,0,1,0,12.373V1.289A.289.289,0,0,1,.289,1Z",
    transform: "translate(467.079 292.534)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c1",
    width: 5.568,
    height: 14.692,
    rx: 0.289,
    transform: "translate(474.012 290.505)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint2);
export default __webpack_public_path__ + "static/media/point2.cc3a344b.svg";
export { ForwardRef as ReactComponent };